import { ScrollToTab } from './scroll-to-tab.directive';
import { IonicTabService } from './tabs.service';

export default angular
  .module('sfMobile.services.tabs', ['ionic'])
  .directive('scrollToTab', ScrollToTab)
  .service('tabsService', IonicTabService).name;
